/**
 * Created by mac on 12/30/20
 */

const Workers = function (slot) {
    this.slot = slot;

    this.regular = [];
    this.instant = [];

    this.onAddWorker = function () {};

    this.onChangeStatusListener = function () {};
    this.onChangeTotalAmount = function () {};
    this.onWorkerPurchaseFinished = function () {};

    this.speedupCheckInterval = new cleverapps.Interval(this.assignSpeedUpBonus.bind(this, undefined), cleverapps.parseInterval(Workers.SPEEDUP_BONUS_CHECK_INTERVAL));
    cleverapps.rewardedAdsManager.onRewardedRefresh(this.changeRewardedState.bind(this), this);
};

Workers.prototype.getInfo = function () {
    const info = {
        bw: cleverapps.compactTime(this.bonusWorkerEnd, { seconds: true })
    };

    this.regular.forEach((worker) => {
        const workerInfo = worker.save();
        if (workerInfo) {
            Object.assign(info, workerInfo);
        }
    });

    return info;
};

Workers.prototype.destructor = function () {
    this.regular.forEach((worker) => {
        worker.destructor();
    });

    this.clearBonusWorkerTimeout();
    this.speedupCheckInterval.stop();
    this.destroyed = true;

    runCleaners(this);
};

Workers.prototype.save = function () {
    this.slot.save("workers", this.getInfo());
};

Workers.prototype.load = function () {
    const stored = this.slot.load("workers") || {};

    this.bonusWorkerEnd = cleverapps.expandTime(stored.bw, { seconds: true }) || stored.bonusWorkerEnd;

    const workers = stored.regular || [];

    Object.keys(stored).forEach((key) => {
        if (!parseInt(key)) {
            return;
        }

        const info = {};
        info[key] = stored[key];
        workers.push(info);
    });

    this.regular = [];

    workers.forEach((worker) => {
        this.regular.push(new GameWorker(this.chooseFreeSkin(), worker));
    });

    this.instant = [];

    this.assignSpeedUpBonus();
};

Workers.prototype.runSpecialWorkers = function () {
    this.runBonusWorkerTimeout();

    if (cleverapps.subscription && cleverapps.subscription.isActive()) {
        this.addSubscriptionWorker(true);
    }

    this.adjustRegularIfNeeded(true);
};

Workers.prototype.setBonusWorkerEnd = function (bonusWorkerEnd) {
    if (this.bonusWorkerEnd === bonusWorkerEnd) {
        return;
    }

    this.bonusWorkerEnd = bonusWorkerEnd;
    this.save();
};

Workers.prototype.removeBonusWorker = function () {
    this.setBonusWorkerEnd(undefined);
    this.clearBonusWorkerTimeout();
    this.adjustRegularIfNeeded();
};

Workers.prototype.bonusWorkerLeftTime = function () {
    if (!this.bonusWorkerEnd) {
        return 0;
    }
    return this.bonusWorkerEnd - Date.now();
};

Workers.prototype.clearBonusWorkerTimeout = function () {
    if (this.bonusWorkerTimeout) {
        clearTimeout(this.bonusWorkerTimeout);
        this.bonusWorkerTimeout = undefined;
    }
};

Workers.prototype.runBonusWorkerTimeout = function () {
    this.clearBonusWorkerTimeout();

    const leftTime = this.bonusWorkerLeftTime();
    if (leftTime > 0) {
        this.bonusWorkerTimeout = new cleverapps.LongTimeout(this.runBonusWorkerTimeout.bind(this), leftTime);
    } else {
        this.removeBonusWorker();
    }
};

Workers.prototype.isAdsWorkerAvailable = function () {
    return !this.isBonusWorkerBuyed() && this.countRegularTotal() <= this.countRegularLimit();
};

Workers.prototype.isFreeWorkerAvailable = function () {
    return !this.isBonusWorkerBuyed()
        && cleverapps.user.checkAvailable({ level: 5 }) && !cleverapps.user.checkAvailable({ level: 8 })
        && !this.slot.load("local_free_worker") && !cleverapps.skins.getSlot("noReceiveWorkerWindow");
};

Workers.prototype.freeWorkerGained = function () {
    this.slot.save("local_free_worker", true);
};

Workers.prototype.freeWorkerLost = function () {
    this.slot.remove("local_free_worker");
};

Workers.prototype.isBonusWorkerBuyed = function () {
    return this.bonusWorkerLeftTime() > 0;
};

Workers.prototype.addBonusWorkerPeriod = function (period, silent) {
    if (!this.isBonusWorkerBuyed()) {
        this.setBonusWorkerEnd(Date.now() + period);
    } else {
        this.setBonusWorkerEnd(this.bonusWorkerEnd + period);
    }
    this.runBonusWorkerTimeout();
    this.adjustRegularIfNeeded(silent);
    this.save();
};

Workers.prototype.getProduct = function () {
    return Product.CreateByHardPrice(Workers.BONUS_WORKER_PRICE, {
        type: "worker",
        expedition: cleverapps.meta.selectedLocationId()
    });
};

Workers.prototype.getPriceTag = function () {
    return this.getProduct().getCurrentPrice();
};

Workers.prototype.buyBonusWorker = function () {
    this.getProduct().buy(this.processWorkerBought.bind(this), { noRewardWindow: true });
};

Workers.prototype.processWorkerBought = function (success) {
    if (!success) {
        this.onWorkerPurchaseFinished(false);
        return;
    }

    cleverapps.metrics.logEvent(cleverapps.EVENTS.SPENT.WORKER);

    cleverapps.focusManager.display({
        focus: "processWorkerBought",
        stack: true,
        action: (f) => {
            new RewardWindow({ worker: Workers.BONUS_WORKER_PERIOD });
            cleverapps.focusManager.onceNoWindowsListener = f;
        }
    });

    if (this.canWalk()) {
        this.wantsToShowBoughtWorker = true;
    }

    this.onWorkerPurchaseFinished(true);
};

Workers.prototype.watchAdsBonusWorker = function () {
    cleverapps.rewardedAdsManager.playRewarded(AdsLimits.TYPES.WORKER, () => {
        cleverapps.focusManager.display({
            stack: true,
            focus: "watchAdsBonusWorker",
            action: function (f) {
                new RewardWindow({ worker: Workers.ADS_BONUS_WORKER_PERIOD });
                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        });

        if (this.canWalk()) {
            this.wantsToShowBoughtWorker = true;
        }

        this.onWorkerPurchaseFinished(true);
    });
};

Workers.prototype.showBoughtWorker = function () {
    this.wantsToShowBoughtWorker = false;

    let freshWorker;

    for (let i = 0; i < this.regular.length; ++i) {
        const worker = this.regular[i];

        if (!worker.isBusy() && !worker.hasPosition()) {
            freshWorker = worker;
            break;
        }
    }

    if (!freshWorker) {
        return;
    }

    const centerCell = Map2d.currentMap.getScreenCenterCell();
    const workerCell = freshWorker.findNearestAvailableCell(centerCell);
    if (!workerCell) {
        return;
    }

    cleverapps.focusManager.display({
        focus: "showBoughtWorker",
        actions: [
            function (f) {
                freshWorker.move(workerCell);

                Map2d.currentMap.focusOnUnit(workerCell, {
                    allowScrollWithFocus: true,
                    callback: f
                });
            }
        ]
    });
};

Workers.prototype.addSubscriptionWorker = function (silent) {
    const locationConfig = cleverapps.meta.getSelectedLocation().locationConfig;
    if (locationConfig.usesWorkers && locationConfig.usesWorkers.addBySubscription && Subscription.IsAvailable() && cleverapps.subscription.isActive()) {
        this.adjustRegularIfNeeded(silent);
        this.save();
    }
};

Workers.prototype.adjustRegularIfNeeded = function (silent) {
    const limit = this.countRegularLimit();

    let removed = false, added = false;

    for (let i = 0; i < this.regular.length && this.regular.length > limit; ++i) {
        const worker = this.regular[i];
        if (!worker.isBusy()) {
            worker.destructor();
            worker.onRemove();
            this.regular.splice(i, 1);
            removed = true;
            --i;
        }
    }

    while (this.regular.length < limit) {
        this.addRegular(silent);
        added = true;
    }

    if (removed || added) {
        this.save();
    }

    if (!silent) {
        if (removed || added) {
            this.onChangeTotalAmount();
        }
    }

    this.wantsToShowBonusWorkerWindow = !this.isBonusWorkerBuyed() && removed;
};

Workers.prototype.countRegularFree = function () {
    return this.regular.filter((worker) => !worker.isBusy() && worker.isInitialized()).length;
};

Workers.prototype.countRegularTotal = function () {
    return this.regular.length;
};

Workers.prototype.countRegularLimit = function () {
    const locationConfig = cleverapps.meta.getSelectedLocation().locationConfig;

    let limit = locationConfig.usesWorkers ? locationConfig.usesWorkers.amount : 2;

    if (this.isBonusWorkerBuyed()) {
        const bonusWorkerLimit = locationConfig.usesWorkers && locationConfig.usesWorkers.bonusWorkers !== undefined ? locationConfig.usesWorkers.bonusWorkers : 1;
        limit += Math.min(1, bonusWorkerLimit);
    }

    if (cleverapps.meta.getSelectedLocation().locationConfig.isMain && cleverapps.subscription && cleverapps.subscription.isActive()) {
        limit += 1;
    }
    return limit;
};

Workers.prototype.addRegular = function (silent) {
    const worker = new GameWorker(this.chooseFreeSkin());
    this.regular.push(worker);
    this.onAddWorker(worker);
    if (!silent) {
        this.onChangeTotalAmount();
    }
};

Workers.prototype.addInstant = function (worker) {
    const index = this.instant.indexOf(worker);
    if (index === -1) {
        this.instant.push(worker);
    }
};

Workers.prototype.removeInstant = function (worker) {
    const index = this.instant.indexOf(worker);
    if (index !== -1) {
        this.instant.splice(index, 1);
    }
};

Workers.prototype.hasInstant = function () {
    return this.listInstantFree().length > 0;
};

Workers.prototype.isRetiredWorker = function (worker) {
    return !this.regular.includes(worker);
};

Workers.prototype.findAssigned = function (unit) {
    if (!unit) {
        return;
    }

    for (let i = 0; i < this.regular.length; i++) {
        const worker = this.regular[i];
        if (worker.unit === unit) {
            return worker;
        }
    }
};

Workers.prototype.findInstantAssigned = function (buildable) {
    for (let i = 0; i < this.instant.length; i++) {
        const worker = this.instant[i];
        if (worker.assignment === buildable) {
            return worker;
        }
    }
};

Workers.prototype.findFree = function (cell, wantsSwitch) {
    const free = [];
    const switchable = [];

    for (let i = 0; i < this.regular.length; ++i) {
        const worker = this.regular[i];

        if (!worker.isInitialized()) {
            continue;
        }

        if (!worker.isBusy()) {
            free.push(worker);
            continue;
        }

        if (wantsSwitch && this.canSwitchWorkers() && worker.canSkipAnimation()) {
            switchable.push(worker);
        }
    }

    const selected = free.length ? free : switchable;

    if (!cell || !selected.length) {
        return selected[0];
    }

    let minDistance = undefined;
    let minWorker = undefined;

    for (let i = 0; i < selected.length; ++i) {
        const worker = selected[i];

        const distance = worker.position && cc.pDistanceSQ(cell, worker.position);
        if (minDistance === undefined || distance < minDistance) {
            minDistance = distance;
            minWorker = worker;
        }
    }

    return minWorker;
};

Workers.prototype.findLeastBusy = function (Component) {
    let leastWorker, leastTime = Infinity;
    this.listBusy().forEach((worker) => {
        if (Component && !worker.unit.findComponent(Component)) {
            return;
        }

        if (leastTime > worker.getTimeLeft()) {
            leastWorker = worker;
            leastTime = worker.getTimeLeft();
        }
    });
    return leastWorker;
};

Workers.prototype.listBusy = function () {
    return this.regular.filter((worker) => worker.isBusy());
};

Workers.prototype.listInstantFree = function () {
    return this.instant.filter((worker) => !worker.isWorking());
};

Workers.prototype.listInstant = function () {
    return this.instant;
};

Workers.prototype.listRegular = function () {
    return this.regular;
};

Workers.prototype.assignSpeedUpBonus = function (worker) {
    if (!this.destroyed && !this.denySpeedUpBonus() && cleverapps.adsLimits.state(AdsLimits.TYPES.SPEEDUP) === AdsLimits.STATE_READY) {
        const workers = worker ? [worker] : this.regular;
        worker = PseudoRandom.GET().choose(workers.filter((worker) => worker.isSpeedUpBonusAvailable() && !worker.isSpeedUpBonusActive()));

        if (worker) {
            worker.setSpeedUpBonus();
        }
    }
};

Workers.prototype.changeRewardedState = function () {
    if (!connector.ads.isRewardedAvailable) {
        this.regular.forEach((worker) => {
            worker.clearBonus();
        });
    }
};

Workers.prototype.placeNotPositionedWorkers = function (fogId) {
    if (!this.canWalk()) {
        return;
    }

    const workers = [];
    for (let i = 0; i < this.regular.length; ++i) {
        const worker = this.regular[i];

        if (!worker.isBusy() && !worker.hasPosition()) {
            workers.push(worker);
        }
    }

    if (!workers.length) {
        return;
    }

    const map = Map2d.currentMap;

    const cells = (map.regions[fogId] && map.regions[fogId].positions || []).filter((cell) => map.isGround(cell.x, cell.y) && !map.getUnit(cell.x, cell.y) && !map.getFog(cell.x, cell.y)).map((cell) => cc.p(cell));
    if (!cells.length) {
        return;
    }

    const centroids = this.divideByClusters(cells, workers.length);
    for (let i = 0; i < workers.length; i++) {
        if (centroids[i]) {
            workers[i].move(centroids[i]);
        }
    }

    this.save();
};

Workers.prototype.divideByClusters = function (cells, k) {
    const grouped = {};
    const map2dView = Map2d.currentMap.getMapView();

    cells.forEach((cell) => {
        const x = Math.round(map2dView.toScreen(cell.x, cell.y).x);

        if (!grouped[x]) {
            grouped[x] = [];
        }

        grouped[x].push(cell);
    });

    const clusters = [];

    Object.keys(grouped).sort().forEach((x, index, groups) => {
        index = Math.floor(index / groups.length * k);

        if (!clusters[index]) {
            clusters[index] = [];
        }

        clusters[index] = clusters[index].concat(grouped[x]);
    });

    return clusters.map((cluster) => cc.getCenterPoint(cluster));
};

Workers.prototype.trimCellShift = function (x, y, cellShift) {
    let sX = cellShift.x;
    let sY = cellShift.y;

    const cantPass = function (cX, cY) {
        const map = Map2d.currentMap;
        return map.isImpassableGround(cX, cY) || !map.isGround(cX, cY);
    };

    if (cantPass(x - 1, y)) {
        sX = Math.max(sX, 0);
    }
    if (cantPass(x + 1, y)) {
        sX = Math.min(sX, 0);
    }
    if (cantPass(x, y - 1)) {
        sY = Math.max(sY, 0);
    }
    if (cantPass(x, y + 1)) {
        sY = Math.min(sY, 0);
    }

    if (cantPass(x - 1, y - 1) && sX < 0 && sY < 0
        || cantPass(x + 1, y - 1) && sX > 0 && sY < 0
        || cantPass(x - 1, y + 1) && sX < 0 && sY > 0
        || cantPass(x + 1, y + 1) && sX > 0 && sY > 0) {
        sX = 0;
        sY = 0;
    }

    if (!GameWorker.canMove(cc.p(x, y))) {
        sX = 0;
        sY = 0;
    }

    return cc.p(sX, sY);
};

Workers.prototype.tryMove = function (cell, cellShift) {
    cellShift = this.trimCellShift(cell.x, cell.y, cellShift);
    const worker = this.findFree(cell);
    if (!worker) {
        if (!this.onlyOneWorkerAvailable()) {
            cleverapps.centerHint.createTextHint(Messages.get("Workers.busy"));
        }
        return GameWorker.canMove(cell);
    }

    if (!worker.move(cell, cellShift)) {
        cleverapps.centerHint.createTextHint(Messages.get("Workers.cantMove"));
        return false;
    }

    return true;
};

Workers.prototype.chooseFreeSkin = function () {
    let skins = cleverapps.skins.getSlot("walkingWorkersSkins");
    if (!skins) {
        return;
    }

    skins = skins.reduce((result, skin) => {
        result[skin] = 0;
        return result;
    }, {});

    this.regular.forEach((worker) => {
        skins[worker.getSkin()] += 1;
    });

    return Object.keys(skins).sort((a, b) => skins[a] - skins[b])[0];
};

Workers.prototype.onlyOneWorkerAvailable = function () {
    const locationConfig = cleverapps.meta.getSelectedLocation().locationConfig;
    if (locationConfig.usesWorkers) {
        return locationConfig.usesWorkers.amount === 1 && !locationConfig.usesWorkers.bonusWorkers;
    }
};

Workers.prototype.canSwitchWorkers = function () {
    const locationConfig = cleverapps.meta.getSelectedLocation().locationConfig;
    if (locationConfig.usesWorkers) {
        return locationConfig.usesWorkers.canSwitch;
    }
};

Workers.prototype.canWalk = function () {
    const locationConfig = cleverapps.meta.getSelectedLocation().locationConfig;
    if (locationConfig.usesWorkers) {
        return locationConfig.usesWorkers.canWalk;
    }
};

Workers.prototype.denySpeedUpBonus = function () {
    const locationConfig = cleverapps.meta.getSelectedLocation().locationConfig;
    if (locationConfig.usesWorkers) {
        return locationConfig.usesWorkers.denySpeedUpBonus;
    }
};

Workers.ShowFinishedWorker = function (f) {
    const worker = Map2d.currentMap.workers.findLeastBusy();
    if (!worker || worker.getTimeLeft() > 0) {
        f();
        return;
    }

    const controls = ["MenuBarAvatarItem", "MenuBarCoinsItem"];
    const questsGroupIcon = cleverapps.sideBar.findIconByClassName(QuestsGroupIcon);
    if (questsGroupIcon) {
        controls.push("QuestsGroupIcon");
    }

    cleverapps.focusManager.showControlsWhileFocused(controls);

    Map2d.currentMap.focusOnUnit(worker.unit, {
        allowScrollWithFocus: true
    });
    Map2dLocation.currentLocation.counter.setTimeout(f, questsGroupIcon ? 3500 : 1500);
};

Workers.BONUS_WORKER_PERIOD = "7 day";
Workers.ADS_BONUS_WORKER_PERIOD = "15 minutes";
Workers.FREE_BONUS_WORKER_PERIOD = "1 day";
Workers.BONUS_WORKER_PRICE = 225;

Workers.SPEEDUP_BONUS_CHECK_INTERVAL = "1 minute";
Workers.SPEEDUP_BONUS_DURATION = "15 minutes";
Workers.SPEEDUP_BONUS_TIME = "15 minutes";
Workers.SPEEDUP_BONUS_MINIMUM_REQUIRED_TIME = "1 minutes";

if (cleverapps.config.debugMode) {
    Workers.SPEEDUP_BONUS_DURATION = "30 seconds";
}

Workers.BOOST_ANIMATE_DURATION = 1250;

Restorable.BY_TYPE["worker"] = new Restorable({
    location: Restorable.LocationContextExpedition,
    find: () => Map2d.currentMap && Map2d.currentMap.workers,
    give: (workers) => workers.processWorkerBought(true)
});

UniversalSlot.registerTable("workers", {
    getInfo: (slot) => slot.load("workers"),
    updateInfo: (slot, serverData) => slot.save("workers", serverData, true)
});